import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = theme => ({
  root: {
    position: 'relative',
  },
  [theme.breakpoints.up('lg')]: {
    root: {
      padding: theme.spacing(4),
      top: '50%',
      transform: 'translateY(-50%)',
    },
  },
});

const Content = ({
  className,
  classes,
  children,
}) => {
  return (
    <div
      className={classNames(classes.root, className)}
    >
      {children}
    </div>
  );
};

Content.defaultProps = {
  className: '',
};

Content.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export default withStyles(styles)(Content);
